import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPin, CheckCircle2 } from 'lucide-react';
const NAMES = ['Marcelo', 'Carlos', 'Fabián', 'Santiago', 'Diego', 'Cecilia', 'Juan', 'Martín', 'Lucas', 'Pablo', 'Alejandro', 'Nicolás'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Santa Fe', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Neuquén'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setCurrentBuyer({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000); // Hide after 5 seconds
    };
    // Initial delay
    const initialTimer = setTimeout(() => {
      showPopup();
    }, 10000);
    // Recurring timer
    const recurringTimer = setInterval(() => {
      showPopup();
    }, 35000); // Every 35 seconds
    return () => {
      clearTimeout(initialTimer);
      clearInterval(recurringTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-31">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-4 left-4 z-50 max-w-sm bg-white rounded-lg shadow-2xl border border-gray-100 p-4 flex items-start gap-4" data-id="element-32">
          <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-33">
            <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-34" />
          </div>
          <div data-id="element-35">
            <p className="text-sm text-gray-500 font-medium mb-1" data-id="element-36">
              Alguien acaba de comprar
            </p>
            <p className="text-base font-bold text-gray-900 leading-tight" data-id="element-37">
              Megapack FUTSAL 360
            </p>
            <div className="flex items-center gap-1 mt-2 text-xs text-gray-500" data-id="element-38">
              <MapPin className="w-3 h-3" data-id="element-39" />
              <span data-id="element-40">
                {currentBuyer.name} de {currentBuyer.city}, 🇦🇷
              </span>
            </div>
            <p className="text-xs text-gray-400 mt-1" data-id="element-41">Hace unos minutos</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}